(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar-promo"]) return;
  try {
    
  const announcementBarSlider = new Swiper('.announcement-bar', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  const announcementBarSlider = new Swiper('.announcement-bar', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Mobile dropdowns
  const headerItems = document.querySelectorAll('.footer__heading-mobile');

  headerItems.forEach(header => {
    header.addEventListener('click', event => {
      const parent = header.parentElement;
      const content = header.nextElementSibling;

      if (parent.classList.contains('active')) {
        parent.classList.remove('active');
        slideUp(content, 400);
      } else {
        parent.classList.add('active');
        slideDown(content, 400);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

// Transparent header
  const header = document.querySelector('.normal-page .outer-header-wrapper')
  if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100 ) {
      header.classList.add('scrolled')
  } else {
      header.classList.remove('scrolled')
  }

  window.addEventListener('scroll', () => {
    scrollPosition = window.scrollY;

    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100 ) {
      header.classList.add('scrolled')
    } else {
      header.classList.remove('scrolled')
    }
    
  });

  


  const openSearch = document.querySelector('.js-open-search');
  const closeSearch = document.querySelector('.js-close-search');
  const search = document.querySelector('.header__search');

  if (openSearch) {
    openSearch.addEventListener('click', () => {
      if (search.classList.contains('is-visible')) {
        search.classList.remove('is-visible');
      } else {
        search.classList.add('is-visible');
      }
    });
  }

  if (closeSearch) {
    closeSearch.addEventListener('click', () => {
      search.classList.remove('is-visible');
    }); 
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const accordions = document.querySelectorAll('.accordion-button');

  accordions.forEach(accordion => {
    accordion.addEventListener('click', event => {
      const parent = event.target.parentElement;
      const content = parent.querySelector(".accordion-content")

      if (!parent.classList.contains('active')) {
        parent.classList.add('active');
        slideDown(content, 300);
      } else {
        parent.classList.remove('active');
        slideUp(content, 300);
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-header"]) return;
  try {
    

// Transparent header
  const header = document.querySelector('.outer-header-wrapper')
  if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100 ) {
      header.classList.add('scrolled')
  } else {
      header.classList.remove('scrolled')
  }

  window.addEventListener('scroll', () => {
    scrollPosition = window.scrollY;

    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100 ) {
      header.classList.add('scrolled')
    } else {
      header.classList.remove('scrolled')
    }
  });


  const openSearch = document.querySelector('.js-open-search');
  const closeSearch = document.querySelector('.js-close-search');
  const search = document.querySelector('.header__search');

  openSearch.addEventListener('click', () => {
    if (search.classList.contains('is-visible')) {
      search.classList.remove('is-visible');
    } else {
      search.classList.add('is-visible');
    }
  });

  closeSearch.addEventListener('click', () => {
    search.classList.remove('is-visible');
  }); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !window.DesignMode) return;
  try {
    
  
    let collectionNavSection = document.querySelector(".collection-list-navigation")
    let collectionNavItems = document.querySelectorAll(".collection-list-navigation__item")

    if (collectionNavSection && !document.querySelector('.collection-list-navigation-clone')){
        let clone = collectionNavSection.cloneNode(true)
        clone.classList.remove('hide-desktop','hide-mobile')
        clone.classList.add('collection-list-navigation-clone')

        let insertBefore = document.querySelector("#MainContent .shopify-section:first-child")
        document.querySelector("#MainContent").insertBefore(clone, insertBefore)
    }
    if( collectionNavItems ){
        collectionNavItems.forEach( item => {
            let itemClone = item.cloneNode(true)
            let collectionNavContainer = document.querySelector('.collection-list-navigation-clone .collection-list-navigation__list')
            collectionNavContainer.appendChild(itemClone)
        })
    }

    if( document.querySelector('.collection-list-navigation-clone') ){
        let navHeight = document.querySelector(".outer-header-wrapper").clientHeight;
        let cloneHeight = document.querySelector(".collection-list-navigation-clone").clientHeight;

        let cloneNavLinks = document.querySelectorAll('.collection-list-navigation-clone .collection-list-navigation__item')
        // Scroll to link
        cloneNavLinks.forEach((link) => {
            link.addEventListener("click", (event) => {
                event.preventDefault();
                const section = document.querySelector(`.collection-product-list__wrapper[data-section="${event.target.dataset.section}"]`)
                const parent = section.closest(".collection-product-list")
                
                window.scrollTo({
                top: (parent.offsetTop + section.offsetTop) - navHeight,
                behavior: "smooth",
                });
            });
        });            
    }    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simple-testimonials"] && !window.DesignMode) return;
  try {
    
    const simpleTestimonial = new Swiper('.simple-testimonials__inner', {
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
          nextEl: ".simple-testimonials-button-next",
          prevEl: ".simple-testimonials-button-prev",
        }
    }) 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !window.DesignMode) return;
  try {
    
    const testimonialImageSlider = new Swiper('.testimonial__images', {
        slidesPerView: 2,
        spaceBetween: 18,
        loop: true,
        allowTouchMove: false
    })

    const testimonialImageSliderMobile = new Swiper('.testimonial__images-mobile', {
        slidesPerView: 1.5,
        spaceBetween: 18,
        loop: false,
        centeredSlides: true,
        allowTouchMove: true
    })

    const testimonialQuoteSlider = new Swiper('.testimonial__quotes', {
        slidesPerView: 1,
        spaceBetween: 18,
        effect: 'fade',
        allowTouchMove: false,
        fadeEffect: {
            crossFade: true
        },
        pagination: {
          el: ".testimonial-pagination",
          type: "progressbar",
        },
        navigation: {
          nextEl: ".testimonial-button-next",
          prevEl: ".testimonial-button-prev",
        }
    })

    testimonialQuoteSlider.on('slideChange', slider => {
        let idx = slider.realIndex;
    
        testimonialImageSlider.slideToLoop(idx);
        // testimonialImageSliderMobile.slideToLoop(idx);
    });

  // testimonialQuoteSlider.controller.control = testimonialImageSlider;
  testimonialQuoteSlider.controller.control = testimonialImageSliderMobile;
  testimonialImageSliderMobile.controller.control = testimonialQuoteSlider;
    


  } catch(e) { console.error(e); }
})();
})();
